import {
    TOGGLE_QUESTIONNAIRE_API_REQUEST,
    TOGGLE_QUESTIONNAIRE_API_SUCCESS,
    TOGGLE_QUESTIONNAIRE_API_FAILURE,
    FETCH_TENANT_TOKEN_REQUEST,
    FETCH_TENANT_TOKEN_SUCCESS,
    FETCH_TENANT_TOKEN_FAILURE,
    REGENERATE_TENANT_TOKEN_REQUEST,
    REGENERATE_TENANT_TOKEN_SUCCESS,
    REGENERATE_TENANT_TOKEN_FAILURE
} from '../actions/externalApiActions';

const initialState = {
    questionnaireTokens: {},
    tenantApiToken: null,
    tenantTokenCreatedAt: null,
    loading: false,
    error: null
};

export default function externalApiReducer(state = initialState, action) {
    switch (action.type) {
        case TOGGLE_QUESTIONNAIRE_API_REQUEST:
            return { ...state, loading: true, error: null };

        case FETCH_TENANT_TOKEN_REQUEST:
        case REGENERATE_TENANT_TOKEN_REQUEST:
            return { ...state, loading: true, error: null, tenantApiToken: null, tenantTokenCreatedAt: null };

        case TOGGLE_QUESTIONNAIRE_API_SUCCESS:
            return {
                ...state,
                loading: false,
                questionnaireTokens: {
                    ...state.questionnaireTokens,
                    [action.payload.questionnaireId]: {
                        token: action.payload.token,
                        enabled: action.payload.enabled,
                        createdAt: action.payload.createdAt
                    }
                }
            };

        case FETCH_TENANT_TOKEN_SUCCESS:
        case REGENERATE_TENANT_TOKEN_SUCCESS:
            return {
                ...state,
                loading: false,
                tenantApiToken: action.payload.token,
                tenantTokenCreatedAt: action.payload.createdAt
            };

        case TOGGLE_QUESTIONNAIRE_API_FAILURE:
        case FETCH_TENANT_TOKEN_FAILURE:
        case REGENERATE_TENANT_TOKEN_FAILURE:
            return { ...state, loading: false, error: action.payload };

        default:
            return state;
    }
}
